import { serverUrl } from "../config";
const cashOutApi = async (clientId) => {
  try {
    let req = {
      data: {
        clientId: clientId,
      },
    };

    const res = await fetch(`${serverUrl}/cashout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    });

    if (res.ok) {
      const jsonData = await res.json();
      return {
        clientId: jsonData["correlation_id"],
        winningAmount: jsonData["data"]["winningAmount"],
        minesIndexes: jsonData["data"]["minesIndexes"],
        currentBalance: jsonData["data"]["currentBalance"],
      };
    }
  } catch (e) {
    console.error(e);
  }
};
export { cashOutApi };
